import React from 'react';

import mail from '../../../assets/images/svg/mail.svg';
import phoneIcon from '../../../assets/images/svg/phone.svg';
import apiClientConfig from '../../../configs/app';
import { useProfileData } from '../../../hooks';
import { RouteDictionary } from '../../../utils';
import { CustomLink, Image, WithinBlockDecorator } from '../../common';
import { LogoImage } from '../../common/images/types';
import { LogoType } from '../../common/images/types/LogoImage';
import { Container } from '../index';
import styles from './Footer.module.scss';

import './Footer.module.scss';

export const Footer = () => {
  const profileData = useProfileData();

  return (
    <footer className={styles.root}>
      <Container>
        <div className={styles.grid}>
          <div className={styles.main}>
            <div className={styles.logo}>
              <CustomLink to={RouteDictionary.INDEX} aria-label="На главную">
                <WithinBlockDecorator>
                  <LogoImage type={LogoType.HEADER} />
                </WithinBlockDecorator>
              </CustomLink>
            </div>
            <div className={styles.policy}>
              <CustomLink
                className={`${styles.text} ${styles.link}`}
                to={RouteDictionary.RULES_REGISTRATION}
              >
                Правила регистрации
              </CustomLink>
              <CustomLink
                className={`${styles.text} ${styles.link}`}
                to={RouteDictionary.RULES_SERVICE}
              >
                Правила пользования сервисом
              </CustomLink>
              <CustomLink
                className={`${styles.text} ${styles.link}`}
                to={RouteDictionary.PERSONAL_DATA_POLICY}
              >
                Политика обработки персональных данных
              </CustomLink>
            </div>
            <address className={styles.address}>
              <div className={styles.text}>
                {new Date().getFullYear()} © Общество с ограниченной ответственностью
                &quot;Кономика&quot;
              </div>
            </address>
          </div>

          <div className={styles.contacts}>
            <div className={styles.contactBlock}>
              <div className={styles.contact}>
                <Image className={styles.icon} src={phoneIcon} alt="Телефон" />
                <a className={styles.text} href="tel:+74951501667">
                  +7 (495) 150-16-67
                </a>
              </div>

              <div className={styles.contact}>
                <Image className={styles.icon} src={mail} alt="Эл. почта" />
                <a className={styles.text__mail} href="mailto:invest@conomica.ru">
                  invest@conomica.ru
                </a>
              </div>

              {profileData?.assignedManager?.name && (
                <div className={styles.contact}>
                  Ваш менеджер — {profileData.assignedManager.name}
                </div>
              )}
            </div>

            <div className={styles.orgBlock}>
              <div className={styles.text}>ИНН: {apiClientConfig.INN}</div>
              <div className={styles.text}>КПП: {apiClientConfig.KPP}</div>
              <div className={styles.text}>ОГРН: {apiClientConfig.OGRN}</div>
            </div>
          </div>
        </div>
      </Container>
    </footer>
  );
};
